<!--报表 销售退库单-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="medium">
          <el-form-item label="项目点：" v-if="activeName == 'groupMealCustomer'">
            <el-select filterable v-model="searchForm.PROJECT" placeholder="请选择" clearable>
              <el-option v-for="item in projects" :key="item.PROJECT_ID" :label="item.PROJECT_NAME" :value="item.PROJECT_ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商客户：" v-else>
            <el-select filterable v-model="searchForm.GYS" placeholder="请选择">
              <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.SUPPLIER_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="退货日期：">
            <el-date-picker v-model="searchForm.START_END" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" clearable :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="订单日期：">
            <el-date-picker v-model="searchForm.START_END_ORDER" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" clearableab :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="退库日期：" v-if="activeName == 'supplierCustomer'">
            <el-date-picker v-model="searchForm.START_END_RETURN" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" clearableab :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="btn" @click="handleCurrentChange(1)" v-if="activeName == 'groupMealCustomer'">
              筛选
            </el-button>
            <el-button type="primary" class="btn" @click="handleCurrentChange2(1)" v-else>筛选</el-button>
            <el-button type="primary" plain class="btn" @click="$_exportForm" v-if="activeName == 'groupMealCustomer' && fun_dic[113040101]">
              导出
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-tabs type="border-card" @tab-click="handleTabClick" v-model="activeName">
        <el-tab-pane label="团餐客户" name="groupMealCustomer">
          <el-col>
            <el-table :data="tableData" max-height="520" stripe border>
              <el-table-column label="序号" type="index" width="50px"></el-table-column>
              <el-table-column label="订单编号" prop="ORDER_CODE" min-width="100px"></el-table-column>
              <el-table-column label="退货日期" prop="RETURN_DAY" min-width="100px"></el-table-column>
              <el-table-column label="客户名称" prop="TC_NAME" min-width="100px"></el-table-column>
              <el-table-column label="项目点" prop="PROJECT_NAME"></el-table-column>
              <el-table-column label="档口" prop="DK_NAME"></el-table-column>
              <el-table-column label="操作时间" prop="CREATE_TIME"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button @click="openDetail(scope.row)" type="text">查看</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="24">
            <div class="pagination_box" style="text-align: right; margin-top: 10px;">
              <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
                layout="total,prev, pager, next, jumper" :total="totalCount">
              </el-pagination>
            </div>
          </el-col>
        </el-tab-pane>
        <el-tab-pane label="供应商客户" name="supplierCustomer">
          <el-col>
            <el-table :data="supplierCusData" max-height="520" stripe border>
              <el-table-column label="序号" type="index" width="50px"></el-table-column>
              <el-table-column label="订单编号" prop="RETURN_ORDER_CODE" min-width="100px"></el-table-column>
              <el-table-column label="送货日期" prop="SEND_DAY" min-width="100px"></el-table-column>
              <el-table-column label="退货日期" prop="RETURN_DAY" min-width="100px"></el-table-column>
              <el-table-column label="退库日期" prop="WAREHOUSE_RETURN_DAY" min-width="100px"></el-table-column>
              <el-table-column label="客户名称" prop="GYS_NAME" min-width="100px"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button @click="openSupplierDetail(scope.row)" type="text">查看</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="24">
            <div class="pagination_box" style="text-align: right; margin-top: 10px;">
              <el-pagination @current-change="handleCurrentChange2" :current-page.sync="currentPage2" :page-size="pageSize"
                layout="total,prev, pager, next, jumper" :total="totalCount2">
              </el-pagination>
            </div>
          </el-col>
        </el-tab-pane>
      </el-tabs>
    </el-row>
  </div>
</template>
<script>
import { supplierCusFun } from 'api/customerManage';
import { queryReturnWareFun, exportReturnDocForm, salesReturnWarehouseListFun } from 'api/returnWare';
import { haveDSXMDFun } from 'api/sellOrder';
import { getActionFun } from '@/assets/api/login';

export default {
  data() {
    return {
      PAGE_ID: '1130401',
      fun_dic: { 113040101: 0 },
      tableData: [],
      dialogVisible: false,
      inwareDate: [],
      name: '',
      pro_type: '',
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      form: {},
      pName: '',
      returnDialogVisible: false,
      region: '',
      deliverId: '',
      arr: [],
      searchForm: {},
      projects: [],
      companys: [],
      supplierCusData: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      activeName: sessionStorage.getItem('returnGoodsTabActiveName') || 'groupMealCustomer',
      currentPage2: 1,
      totalCount2: 0,
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.$set(this.searchForm, 'PROJECT', this.$store.state.RETURNWAREHOUSE_ALL.PROJECT);
    this.$set(this.searchForm, 'START_END', this.$store.state.RETURNWAREHOUSE_ALL.START_END);
    this.$set(this.searchForm, 'START_END_ORDER', this.$store.state.RETURNWAREHOUSE_ALL.START_END_ORDER);
    this.$set(this.searchForm, 'START_END_RETURN', this.$store.state.RETURNWAREHOUSE_ALL.START_END_RETURN);
    this.$set(this.searchForm, 'GYS', this.$store.state.RETURNWAREHOUSE_ALL.GYS);
    this.queryProjects();
    this.queryCustomer();
    this.queryBeforeFun();
    if (this.activeName == 'groupMealCustomer') {
      this.queryList();
    } else {
      this.querySupplierCusReturnList();
    }
  },
  methods: {
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    posionFun() {
      this.pName = this.form.region;
    },
    // ------------------------拉取数据
    queryList() {
      this.$store.dispatch('RETURNWAREHOUSE_ALL', {
        PROJECT: this.searchForm.PROJECT,
        START_END: this.searchForm.START_END,
        START_END_ORDER: this.searchForm.START_END_ORDER,
      });
      const params = {
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: this.pageSize,
      };
      if (this.searchForm.START_END) {
        params.START_DAY = this.searchForm.START_END[0];
        params.END_DAY = this.searchForm.START_END[1];
      }
      if (this.searchForm.START_END_ORDER) {
        params.ORDER_START_DAY = this.searchForm.START_END_ORDER[0];
        params.ORDER_END_DAY = this.searchForm.START_END_ORDER[1];
      }
      if (this.searchForm.PROJECT) {
        params.PROJECT_ID = this.searchForm.PROJECT;
      }
      queryReturnWareFun(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result[0].list;
          this.totalCount = result[0].TOTAL_COUNT;
        } else {
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryList();
    },
    openDetail(row) {
      this.$router.push({ path: '/returnWareDetail/detail' });
      sessionStorage.setItem('RETURN_ID', row.ID);
      sessionStorage.setItem('returnMess', JSON.stringify(row));
    },
    // 获取项目点
    queryProjects() {
      haveDSXMDFun().then((result) => {
        this.projects = result.length > 0 ? result[0].project : [];
      })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 导出
    // 导出
    $_exportForm() {
      const params = {
      };
      if (this.searchForm.START_END) {
        params.START_DAY = this.searchForm.START_END[0];
        params.END_DAY = this.searchForm.START_END[1];
      }
      if (this.searchForm.START_END_ORDER) {
        params.ORDER_START_DAY = this.searchForm.START_END_ORDER[0];
        params.ORDER_END_DAY = this.searchForm.START_END_ORDER[1];
      }
      if (this.searchForm.PROJECT) {
        params.PROJECT_ID = this.searchForm.PROJECT;
      }
      exportReturnDocForm(params).then((res) => {
        if (res.length == 0) {
          this.$message.show({ text: '暂无数据', type: 'error' });
        } else {
          window.location.href = this.$util.getURLLocalHost(res[0].FILE_PATH);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleTabClick(tab, event) {
      this.currentOrderFlag = Number(tab.index);
      sessionStorage.setItem('returnGoodsTabActiveName', this.activeName);
      if (this.currentOrderFlag == 0) {
        this.currentPage = 1;
        // 团餐客户订单列表
        this.queryList();
      } else if (this.currentOrderFlag == 1) {
        this.currentPage2 = 1;
        // 供应商客户订单列表
        this.querySupplierCusReturnList();
      }
    },
    // -------------------------------------选择客户
    queryCustomer() {
      const params = {};
      supplierCusFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.companys = result[0].list;
            // this.searchForm.GYS = result[0].list[0].SUPPLIER_ID
          } else {
            this.companys = [];
            this.customers = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    querySupplierCusReturnList() {
      this.$store.dispatch('RETURNWAREHOUSE_ALL', {
        GYS: this.searchForm.GYS,
        START_END: this.searchForm.START_END,
        START_END_ORDER: this.searchForm.START_END_ORDER,
        START_END_RETURN: this.searchForm.START_END_RETURN,
      });
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage2 - 1,
      };
      if (this.searchForm.START_END) {
        params.START_DAY = this.searchForm.START_END[0];
        params.END_DAY = this.searchForm.START_END[1];
      }
      if (this.searchForm.START_END_ORDER) {
        params.ORDER_START_DAY = this.searchForm.START_END_ORDER[0];
        params.ORDER_END_DAY = this.searchForm.START_END_ORDER[1];
      }
      if (this.searchForm.START_END_RETURN) {
        params.WAREHOUSE_RETURN_START_DAY = this.searchForm.START_END_RETURN[0];
        params.WAREHOUSE_RETURN_END_DAY = this.searchForm.START_END_RETURN[1];
      }
      if (this.searchForm.GYS) {
        params.GYS_ID = this.searchForm.GYS;
      }
      salesReturnWarehouseListFun(params).then((result) => {
        this.supplierCusData = result.LIST;
        this.totalCount2 = result.TOTAL_COUNT;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange2(e) {
      this.currentPage = e;
      this.querySupplierCusReturnList();
    },
    openSupplierDetail(row) {
      this.$router.push({ path: `/returnWareSupplierCusDetail/${row.SALES_WAREHOUSE_RETURN_ID}`, params: { swrid: row.SALES_WAREHOUSE_RETURN_ID } });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tableManage/returnWarehouse.vue